import { Button } from '@quickmd-llc/design-system'
import EditStateSettingsHeaderView from './components/edit-state-settings-header/EditStateSettingsHeaderView'
import EditStateSettingsBodyView from './components/edit-state-settings-body/EditStateSettingsBodyView'

interface BreadCrumb {
  site: string
  location: string
}

interface EditStateSettingsViewProps {
  breadCrumbs: BreadCrumb[]
  stateName: string
  onSave: () => void
  onCancel: () => void
  onChangePhoneRule: () => void
  onChangeRequiresDrugScreening: () => void
  isPhoneVisitAllowed: boolean | undefined
  requiresDrugScreening: boolean | null | undefined
  onSetDrugScreenRules: (value: string) => void
  drugScreeningText: string | null | undefined
  drugError: string
}

const EditStateSettingsView = ({
  breadCrumbs,
  stateName,
  onSave,
  onCancel,
  onChangePhoneRule,
  onChangeRequiresDrugScreening,
  isPhoneVisitAllowed,
  requiresDrugScreening,
  onSetDrugScreenRules,
  drugScreeningText,
  drugError,
}: EditStateSettingsViewProps) => (
  <div className='flex flex-1 flex-col'>
    {/*
      ess-container:
        padding: 40px 24px 100px 24px → pt-sp-5 px-sp-3 pb-[100px] (100px has no DS spacing token)
        flex-col, min-width 770px, width 100%, box-sizing border-box
        background: var(--surface-secondary, #f6f7f8) → bg-deep-navy-5 (deep-navy[5] = #F6F7F8)
        flex-1 so the grey body fills the viewport down to the fixed footer (otherwise the
        AuthenticatedLayout's white background shows through below short content).
    */}
    <div className='box-border flex w-full min-w-[770px] flex-1 flex-col bg-deep-navy-5 px-sp-3 pb-[100px] pt-sp-5'>
      <EditStateSettingsHeaderView stateName={stateName} breadCrumbs={breadCrumbs} />
      <EditStateSettingsBodyView
        onChangePhoneRule={onChangePhoneRule}
        onChangeRequiresDrugScreening={onChangeRequiresDrugScreening}
        isPhoneVisitAllowed={isPhoneVisitAllowed}
        requiresDrugScreening={requiresDrugScreening}
        onSetDrugScreenRules={onSetDrugScreenRules}
        drugScreeningText={drugScreeningText}
        drugError={drugError}
      />
    </div>
    {/*
      ess-action-bar:
        position fixed, bottom 0, left var(--nav-width) [no DS token — CSS var], right 0
        flex, align-items center, justify-content flex-end, gap 12px
        padding 16px 24px → py-sp-2 px-sp-3
        background #ffffff → bg-white
        border-top 1px solid var(--border-card, #141E1F1A) → border-t border-shade-10
        z-index 100 → z-[100]
    */}
    <div className='fixed bottom-0 left-[var(--nav-width)] right-0 z-[100] flex items-center justify-end gap-sp-1.5 border-t border-shade-10 bg-white px-sp-3 py-sp-2'>
      <Button priority='secondary' size='s' onClick={onCancel}>
        Cancel
      </Button>
      <Button priority='primary' size='s' onClick={onSave}>
        Save changes
      </Button>
    </div>
  </div>
)

export default EditStateSettingsView
